/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_AwardInputs */

const en_fw_guide_stat_award = /** @type {(inputs: Fw_Guide_Stat_AwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookstore Employees’ Recommended Comics 2024`)
};

const zh_fw_guide_stat_award = /** @type {(inputs: Fw_Guide_Stat_AwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 全国书店员推荐漫画`)
};

/**
* | output |
* | --- |
* | "Bookstore Employees’ Recommended Comics 2024" |
*
* @param {Fw_Guide_Stat_AwardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_award = /** @type {((inputs?: Fw_Guide_Stat_AwardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_AwardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_award(inputs)
	return zh_fw_guide_stat_award(inputs)
});
export { fw_guide_stat_award as "fw.guide.stat.award" }